/*
 * author: wxq
 * createdTime: 2019/06/10
 * */

/**
 * dateApi                     api
 * searchParams
 */
import React, { PureComponent } from 'react';
import { Cascader } from 'antd';
import { getData } from '@util';
class CsxFormCascader extends PureComponent {
  constructor() {
    super();
    this.state = {
      menu: [], // 下拉菜单
      type: 1, // 当前的步骤
      size: 4, // 几级联动停止
    };
  }
  componentDidMount() {
    const { dateApi, data } = this.props;
    if (data) {
      const menu = this.getMenu(data);
      this.setState({
        menu,
      });
    } else {
      dateApi && this.getAsyncDate(dateApi);
    }
  }
  getAsyncDate(dateApi) {
    const reqData = { api: dateApi };
    const {
      searchParams,
      searchParams: { type },
      size,
    } = this.props;
    if (searchParams) {
      reqData.searchParams = searchParams;
    }
    getData(reqData).then(data => {
      if (data.result.length) {
        const menu = this.getMenu(data.result);
        // console.log(JSON.stringify(menu),111)
        this.setState({ type: type + 1, menu, size });
      }
    });
  }

  // 组合treeData数据，数据格式如下
  // [label: 'Node1',value: '001',children: []]
  getMenu(data) {
    // 以后要改 todo
    const menuData = [];
    const { size, type } = this.state;
    const { selectItem } = this.props;
    data.map(o => {
      const obj = {
        value: o[selectItem.key],
        label: o[selectItem.valueKey],
        isLeaf: false,
      };
      if (size == type + 1) {
        obj.isLeaf = true;
      }
      menuData.push(obj);
    });
    // const {selectItem} = this.props
    // let childrenBox = []
    // for (let i = 0; i < data.length; i++) {
    //   let box = {}
    //   box.title = Array.isArray(selectItem.valueKey) ? selectItem.valueKey.map((x, y) => data[i][x]).join('') : data[i][selectItem.valueKey]
    //   box.value = data[i][selectItem.key]
    //   box.key = data[i][selectItem.key]
    //   if (data[i].children) {
    //     // box.isLeaf = true
    //     box.children = this.getMenu(data[i].children)
    //   }
    //   childrenBox.push(box)
    // }
    // return childrenBox
    return menuData;
  }

  // 选中下拉框的回调
  onChange = (key, valueObj) => {
    const obj = key.length
      ? {
          value: valueObj,
          children: key,
        }
      : undefined;
    this.props.onChange(obj);
  };
  loadData = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    const { dateApi } = this.props;
    const { type, menu } = this.state;
    targetOption.loading = true;
    const reqData = {
      api: dateApi,
      searchParams: {
        parentCode: targetOption.value,
        type,
      },
    };
    getData(reqData).then(data => {
      if (data.result.length) {
        targetOption.loading = false;
        targetOption.children = this.getMenu(data.result);
        this.setState({
          menu,
          type: type + 1,
        });
      }
    });
  };
  render() {
    const { value, style } = this.props;
    const { menu } = this.state;
    return (
      <Cascader
        style={style}
        placeholder="请选择"
        value={value && value.children}
        options={menu}
        getPopupContainer={triggerNode => triggerNode.parentNode}
        onChange={this.onChange}
        loadData={this.loadData}
        changeOnSelect
      />
    );
  }
}
export default CsxFormCascader;
